import { IAppState } from '../../../../../AppModulesWrapper';
import { ERestrictionType } from '../types';
import { createSelector } from 'reselect';
import { selectPromotionRestrictionType } from './selectPromotionRestrictionType';

export const selectIsPromotionSubagentLimitExceed = createSelector(
  (state: IAppState) => selectPromotionRestrictionType(state),
  (restrictionType: ERestrictionType | undefined): boolean =>
    restrictionType === ERestrictionType.SubAgentLimitExceeded,
);
